module.exports = __webpack_public_path__ + "img/dedicated-left-4x.157e2d87.png";